export const PRODUCT_INFO_SEARCH_QUERY = `query productInfoSearch($id: ProductInfoProperties!){
  productInfoSearch(id:$id) {
    id
    name
    shortcut
    isDropdown
    allowsMultiple
    isRequired
    values{
      id
      name
    }
    }
}
`